import React, { useState } from "react";
import Dialog from "./Dialog";
import Button from "./Button";
import Select from "./Select";

const FilterModal = ({ open, onClose, fields = [], onApply }) => {
  const [values, setValues] = useState({});

  const handleChange = (name, value) => {
    setValues((prev) => ({ ...prev, [name]: value }));
  };

  const buildQueryString = () => {
    const params = new URLSearchParams();

    Object.entries(values).forEach(([key, value]) => {
      if (value === undefined || value === null) return;
      if (typeof value === "string" && value.trim() === "") return;
      if (Array.isArray(value) && value.length === 0) return;

      if (Array.isArray(value)) {
        value.forEach((v) => params.append(key, v));
      } else {
        params.append(key, value);
      }
    });

    const query = params.toString();
    return query ? `?${query}` : "";
  };

  const handleApply = () => {
    const queryString = buildQueryString();
    if (typeof onApply === "function") onApply(queryString);
    if (typeof onClose === "function") onClose();
  };

  const handleReset = () => {
    setValues({});
    if (typeof onApply === "function") onApply("");
    if (typeof onClose === "function") onClose();
  };

  return (
    <Dialog
      isOpen={open}
      onClose={onClose}
      title="Filters"
      size="sm"
      footer={
        <>
          <Button variant="secondary" onClick={handleReset}>
            Clear All
          </Button>
          <Button variant="primary" onClick={handleApply}>
            Apply
          </Button>
        </>
      }
    >
      <div className="flex flex-col gap-4">
        {fields.map((field) => {
          if (field.type === "select") {
            return (
              <div key={field.name}>
                <label className="block text-sm font-medium text-text-secondary mb-2">
                  {field.label}
                </label>
                <Select
                  value={values[field.name] !== undefined ? values[field.name] : ""}
                  onChange={(e) => handleChange(field.name, e.target.value)}
                  wrapperClassName=""
                >
                  <option value="">
                    {field.placeholder ?? "All"}
                  </option>
                  {field.options?.map((opt) => (
                    <option key={String(opt.value)} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </Select>
              </div>
            );
          }

          if (field.type === "text" || field.type === "number") {
            return (
              <div key={field.name}>
                <label className="block text-sm font-medium text-text-secondary mb-2">
                  {field.label}
                </label>
                <input
                  type={field.type}
                  value={values[field.name] ?? ""}
                  placeholder={field.placeholder}
                  onChange={(e) => handleChange(field.name, e.target.value)}
                  className="w-full px-3 py-2 border border-border-light rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary bg-white text-text-dark"
                />
              </div>
            );
          }

          if (field.type === "date") {
            return (
              <div key={field.name}>
                <label className="block text-sm font-medium text-text-secondary mb-2">
                  {field.label}
                </label>
                <input
                  type="date"
                  value={values[field.name] ?? ""}
                  onChange={(e) => handleChange(field.name, e.target.value)}
                  onFocus={(e) => e.target.showPicker?.()}
                  onClick={(e) => e.target.showPicker?.()}
                  className="w-full px-3 py-2 border border-border-light rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary bg-white text-text-dark"
                />
              </div>
            );
          }

          if (field.type === "dateRange") {
            const startName = field.startName || "startDate";
            const endName = field.endName || "endDate";
            return (
              <div key={field.name} className="flex gap-2">
                <div className="flex-1">
                  <label className="block text-sm font-medium text-text-secondary mb-2">
                    {field.startLabel || "Start date"}
                  </label>
                  <input
                    type="date"
                    value={values[startName] ?? ""}
                    onChange={(e) => handleChange(startName, e.target.value)}
                    onFocus={(e) => e.target.showPicker?.()}
                    onClick={(e) => e.target.showPicker?.()}
                    className="w-full px-3 py-2 border border-border-light rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary bg-white text-text-dark"
                  />
                </div>
                <div className="flex-1">
                  <label className="block text-sm font-medium text-text-secondary mb-2">
                    {field.endLabel || "End date"}
                  </label>
                  <input
                    type="date"
                    value={values[endName] ?? ""}
                    onChange={(e) => handleChange(endName, e.target.value)}
                    onFocus={(e) => e.target.showPicker?.()}
                    onClick={(e) => e.target.showPicker?.()}
                    className="w-full px-3 py-2 border border-border-light rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary bg-white text-text-dark"
                  />
                </div>
              </div>
            );
          }

          return null;
        })}
      </div>
    </Dialog>
  );
};

export default FilterModal;
